
import news from "@/components/news.vue";
import news_small from "@/components/news_small.vue";
import noContent from "@/components/noContent.vue";

export default {
  components: { news, news_small },
  name: "index",
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: "news",
      meta: [
        {
          name: "keywords",
          content: "xppen-xfans-news",
        },
        {
          name: "description",
          content: "official information",
        },
      ],
    };
  },
  data() {
    return {
      asyncSource: [],
      asyncSourceSmall: [],
      total: "",
      pageSize: 20, //每页显示条目个数
      currentPage: parseInt(this.$route.query.page) || 1, //当前页
    };
  },
  async asyncData({ $global, query, error }) {
    let asyncSource = [];
    let total = 0;
    let asyncSourceSmall = [];
    try {
      const res = await $global.newList({
        page: query.page == undefined ? 1 : query.page,
      });
      if (res.code == 200) {
        asyncSource = res.data.articleCategoryList.data;
        total = res.data.articleCategoryList.total;
        asyncSourceSmall = res.data.articleListOrder.data;
      }
    } catch (e) {}
    return { asyncSource, total, asyncSourceSmall };
  },
  watchQuery: ["page"],
  mounted() {},
  methods: {
    handleCurrentChange(val) {
      this.$router.push({ url: "/news", query: { page: val } });
    },
  },
};
